import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController,Events } from 'ionic-angular';

/**
 * Generated class for the UsermenuPopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-usermenu-popover',
  templateUrl: 'usermenu-popover.html',
})

export class UsermenuPopoverPage {

  name: string;
  surname: string;
  messagecount: number;
  personal_id: string;
  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public events: Events) {
      this.name = this.navParams.get('name');
      this.surname = this.navParams.get('surname');
      this.messagecount = this.navParams.get('message_count');
      this.personal_id = this.navParams.get('personal_id');
  }

  profileAction(action: string) {
      this.viewCtrl.dismiss();
      this.events.publish('usermenu:action', action);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UsermenuPopoverPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/usermenu-popover/usermenu-popover.ts